module.exports = global.config = {
    restUrl: "https://cws.kone.com/api/",
    environment: "prod",
    pdmUrl: "https://pdm-prod.aws.kone.com/epdm_prod/"
};